import { FC } from "react";

import Image from "next/legacy/image";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import styles from "./style";

const InfoAfterClaiming: FC = () => {
  return (
    <Box sx={styles.iconWrapper}>
      <Image
        src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/octagon.svg`}
        alt="AUTHENTICATED BY UNIQLY"
        width={24}
        height={24}
      />
      <Box>
        <Typography component="h4" variant="h4" sx={styles.h4}>
          AUTHENTICATED BY UNIQLY
        </Typography>
      </Box>
    </Box>
  );
};
export default InfoAfterClaiming;
